import { render } from "./InfiniteList.vue?vue&type=template&id=2a84a746&scoped=true"
import script from "./InfiniteList.vue?vue&type=script&lang=ts"
export * from "./InfiniteList.vue?vue&type=script&lang=ts"

import "./InfiniteList.vue?vue&type=style&index=0&id=2a84a746&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2a84a746"

export default script